import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { backend, mediaurl, blogurl } from "../../../path";
import DashboardMain from "../main";
import DashboardSidebarMain from "../dashsidebar";
import HeaderDashMain from "../../layout/header/dash header";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Pagination from "../../components/pagination";
function DashboardBlogMain() {
  // const [formData, setFormData] = useState([]);
  const [formData, setFormData] = useState({
    category_name: '',
    description: '', // Assuming description is a string
    logo: '', // Assuming logo is a string
  });
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [view, setView] = useState(0);
  const [logo, setLogo] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dummyData, setDummyData] = useState({});
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  const fetchData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getblog", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [pageNumber, pageSize]);

  const handlefileupload = (e) => {
    let formdata = new FormData();
    formdata.append("document", e.target.files[0]);

    fetch(backend + "blogupload", {
      method: "POST",
      body: formdata,
    })
      .then((response) => response.json())
      .then((data) => {
        setFormData({
          ...formData,
          thumbnail: data,
        });
      })
      .catch((error) => {
        console.error("Error during file upload:", error);
      });
  };
  const handlefileuploadImg1 = (e) => {
    let formdata = new FormData();
    formdata.append("document", e.target.files[0]);

    fetch(backend + "blogupload", {
      method: "POST",
      body: formdata,
    })
      .then((response) => response.json())
      .then((data) => {
        setFormData({
          ...formData,
          image_1: data,
        });
      })
      .catch((error) => {
        console.error("Error during file upload:", error);
      });
  };
  const handlefileuploadImg2 = (e) => {
    let formdata = new FormData();
    formdata.append("document", e.target.files[0]);

    fetch(backend + "blogupload", {
      method: "POST",
      body: formdata,
    })
      .then((response) => response.json())
      .then((data) => {
        setFormData({
          ...formData,
          image_2: data,
        });
      })
      .catch((error) => {
        console.error("Error during file upload:", error);
      });
  };
  const handlefileuploadImg3 = (e) => {
    let formdata = new FormData();
    formdata.append("document", e.target.files[0]);

    fetch(backend + "blogupload", {
      method: "POST",
      body: formdata,
    })
      .then((response) => response.json())
      .then((data) => {
        setFormData({
          ...formData,
          image_3: data,
        });
      })
      .catch((error) => {
        console.error("Error during file upload:", error);
      });
  };
  const handlefileuploadImg4 = (e) => {
    let formdata = new FormData();
    formdata.append("document", e.target.files[0]);

    fetch(backend + "blogupload", {
      method: "POST",
      body: formdata,
    })
      .then((response) => response.json())
      .then((data) => {
        setFormData({
          ...formData,
          image_4: data,
        });
      })
      .catch((error) => {
        console.error("Error during file upload:", error);
      });
  };

  const handleFileUpload = async (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    if (file) {
      const formDatas = new FormData();
      formDatas.append("csvFile", file);

      try {
        const response = await fetch(backend + "csvhandlecategory", {
          method: "POST",
          body: formDatas,
          mode: "no-cors",
        });

        if (response.ok) {
          // File successfully uploaded
        } else {
          // Handle error if the request was not successful
        }
      } catch (error) {
        // Handle network errors or other issues
      }

      // Optional: Clear the file input after uploading
      fileInput.value = "";
    }
  };


  const handleStatusOff = (id) => {
    // formData.status = 1;

    dummyData.blog_id = id;
    dummyData.status = 1;

    fetch(backend + "editblogstatus", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`
      },
      body: JSON.stringify(dummyData),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          fetchData()
          // setView(1);
          // Additional success handling code here
          toast.success("Updated", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      })
      .catch((error) => {
        toast.error("Registration failed", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };
  const handleStatus = (id) => {
    // formData.status = 1;

    dummyData.blog_id = id;
    dummyData.status = 0;

    fetch(backend + "editblogstatus", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`
      },
      body: JSON.stringify(dummyData),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          fetchData()
          // setView(1);
          // Additional success handling code here
          toast.success("Updated", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      })
      .catch((error) => {
        console.error("Error during registration:", error);
        toast.error("Registration failed", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleView = (id) => {
    const edit = data.find((item) => item.blog_id === id);
    setView(1);
    setFormData(edit);
  };

  const handlefileuploadEdit = (e) => {
    let formdata = new FormData();
    formdata.append("document", e.target.files[0]);

    fetch(backend + "fileuploadcategory", {
      method: "POST",
      body: formdata,
    })
      .then((response) => response.json())
      .then((data) => {
        setFormData({
          ...formData,
          logo: data,
        });
        setLogo = data;
      })
      .catch((error) => {
        console.error("Error during file upload:", error);
      });
  };

  const handleSubmit = (id) => {
    formData.status = 0;

    fetch(backend + "editblog", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {

          // Additional success handling code here
          toast.success("Category Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        setView(0);
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handlePageClick = (pageNumber) => {
    setPageNumber(pageNumber);
  };
  console.log(formData);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2 d-none d-lg-flex"> */}
          <DashboardSidebarMain />
          {/* </div> */}
          {view === 0 ? (
            <div className="col-lg-12">
              <div className="login_wrap widget-taber-content background-white">
                <div className="padding_eight_all bg-white">
                  <div className="padding_eight_all bg-white">
                    <div className="d-flex justify-content-between mb-20 mt-20">
                      <h3 className="">Blog</h3>
                      <div className="d-flex justify-content-end gap-3">
                        <a href="/blogs-add">
                          <button
                            type="button"
                            className="btn btn-fill-out btn-block hover-up"
                          //   onClick={handleSubmit}
                          >
                            Add New
                          </button>
                        </a>
                        <div>
                          {/* Icon component */}
                          <Icon
                            icon="fa6-solid:file-csv"
                            color="green"
                            className="hover-up"
                            fontSize={46}
                            onClick={() =>
                              document.getElementById("fileInput").click()
                            }
                            style={{ cursor: "pointer" }}
                          />

                          {/* File input */}
                          <input
                            type="file"
                            id="fileInput"
                            accept=".csv"
                            onChange={handlefileupload}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                    <br></br>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-secondary table-hover">
                      <thead className="table-warning">
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Blog Title</th>
                          <th scope="col">Content</th>
                          <th scope="col">Thumbnail</th>
                          <th scope="col">Img 1</th>
                          <th scope="col">Img 2</th>
                          <th scope="col">Img 3</th>
                          <th scope="col">Img 4</th>
                          <th scope="col">Status</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.title}</td>
                            <td>{item.content}</td>
                            <td>{item.thumbnail}</td>
                            <td>{item.image_1}</td>
                            <td>{item.image_2}</td>
                            <td>{item.image_3}</td>
                            <td>{item.image_4}</td>
                            <td>
                              {item.status === 0 ? "Available" : "Not Available"}
                            </td>
                            <td>
                              {item.status === 0 ? (
                                <Icon
                                  icon="carbon:view-filled"
                                  color="green"
                                  className="cursor-pointer ml-2"
                                  fontSize={20}
                                  onClick={() => handleStatusOff(item.blog_id)}
                                />
                              ) : item.status === 1 ? (
                                <Icon
                                  icon="carbon:view-off-filled"
                                  color="#b83e0c"
                                  className="cursor-pointer ml-2"
                                  fontSize={20}
                                  onClick={() => handleStatus(item.blog_id)}
                                />
                              ) : (
                                ""
                              )}{" "}
                              <Icon
                                icon="basil:edit-solid"
                                color="#1a42cc"
                                className="cursor-pointer ml-2"
                                fontSize={20}
                                onClick={() => handleView(item.blog_id)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* <div className="form-group">
                <button
                  type="button"
                  className="btn btn-fill-out btn-block hover-up"
                  onClick={handleSubmit}
                >
                  Register
                </button>
              </div> */}
                <br></br>
                <Pagination
                  currentPage={pageNumber}
                  pageSize={pageSize}
                  totalItems={data.length}
                  onPageChange={handlePageClick}
                />
              </div>
            </div>
          ) : (
            <div className="col-lg-10">
              <div className="login_wrap widget-taber-content background-white">
                <div className="padding_eight_all bg-white">
                  <div className="padding_eight_all bg-white">
                    <div className="d-flex justify-content-between mb-20 mt-20">
                      <h3 className="">Edit Blog</h3>
                      {/* <a href=""> */}
                      <button
                        type="button"
                        className="btn btn-fill-out btn-block hover-up"
                        onClick={() => setView(0)}
                      >
                        Back
                      </button>
                      {/* </a> */}
                    </div>
                    <br></br>
                  </div>
                  {/* <form
                // onSubmit={handleSubmit}
                > */}
                  <input
                    type="hidden"
                    name="_token"
                    value="bVwKUehCmCMBBOuQToUzdDhTTdTBfg78RlsalVJQ"
                    autoComplete="off"
                  />
                  <div className="form__content">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">Blog Title</label>{" "}
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          <input
                            className="form-control"
                            name="title"
                            id="txt-name"
                            type="text"
                            required
                            value={formData.title || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                title: e.target.value,
                              })
                            }
                            placeholder="Category Name"
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="logo">Thumbnail</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          {formData.thumbnail && (
                            <div>
                              <img src={`${blogurl}${formData.thumbnail}` || ""} alt="Thumbnail" width="100" />
                            </div>
                          )}
                          <input
                            className="form-control"
                            name="logo"
                            id="txt-name"
                            type="file"
                            required
                            onChange={(event) => {
                              handlefileupload(event);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="name">Content </label>{" "}
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>

                          <CKEditor
                            editor={ClassicEditor}
                            data={formData.content || ""}  // Ensure content is prefilled
                            onInit={editor => {
                              // You can store the "editor" and use when it is needed.
                              // console.log('Editor is ready to use!', editor);
                            }}

                            onChange={(event, editor) => {
                              const data = editor.getData();
                              // console.log({ event, editor, data });
                              setFormData({
                                ...formData,
                                content: data,
                              })
                            }}
                            onBlur={(event, editor) => {
                              console.log('Blur.', editor);
                            }}
                            onFocus={(event, editor, data) => {
                              console.log('Focus.', editor);
                            }}
                          />

                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="logo">Image 1</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          {formData.image_1 && (
                            <div>
                              <img src={`${blogurl}${formData.image_1}` || ""} alt="Image1" width="100" />
                            </div>
                          )}
                          <input
                            className="form-control"
                            name="logo"
                            id="txt-name"
                            type="file"
                            required
                            onChange={(event) => {
                              handlefileuploadImg1(event);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="logo">Image 2</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          {formData.image_2 && (
                            <div>
                              <img src={`${blogurl}${formData.image_2}` || ""} alt="Image2" width="100" />
                            </div>
                          )}
                          <input
                            className="form-control"
                            name="logo"
                            id="txt-name"
                            type="file"
                            required
                            onChange={(event) => {
                              handlefileuploadImg2(event);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="logo">Image 3</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          {formData.image_3 && (
                            <div>
                              <img src={`${blogurl}${formData.image_3}` || ""} alt="Image3" width="100" />
                            </div>
                          )}
                          <input
                            className="form-control"
                            name="logo"
                            id="txt-name"
                            type="file"
                            required
                            onChange={(event) => {
                              handlefileuploadImg3(event);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="logo">Image 4</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                          {formData.image_4 && (
                            <div>
                              <img src={`${blogurl}${formData.image_4}` || ""} alt="Image4" width="100" />
                            </div>
                          )}
                          <input
                            className="form-control"
                            name="logo"
                            id="txt-name"
                            type="file"
                            required
                            onChange={(event) => {
                              handlefileuploadImg4(event);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-fill-out btn-block hover-up"
                      onClick={() => handleSubmit(formData.blog_id)}
                    >
                      Submit
                    </button>
                  </div>
                  <br></br>
                  {/* </form> */}
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
      <ToastContainer />
    </>
  );
}
export default DashboardBlogMain;
